<div class="table-footer mb-4" *ngIf="isPaginationVisble">
  <ul class="table-count">
    <li>
      Items per page:
    </li>
    <li><select type="text" class="form-select" [(ngModel)]="itemsPerPage" (change)="selectListPerPage($event)">
        <option value="{{item}}" *ngFor="let item of itemsPerPageList">{{item}}</option>
      </select></li>
    <li>{{ listStartsFrom }} – {{ listEndsFrom }} of {{listLength }}</li>
  </ul>
  <div class="pagination-wrapper">
    <ul class="ngx-pagination ng-star-inserted" aria-label="Pagination">
      <li class="pagination-previous ng-star-inserted button-pointer" [ngClass]="{'disabled': ClickedButtonNumber === 1}">
        <a tabindex="0" (click)="previousButton()"><span class="ng-star-inserted"> Previous <span class="show-for-sr">page</span></span></a>
      </li>
      <li *ngFor="let item of pageList" class="ng-star-inserted button-pointer" [ngClass]="{'current':ClickedButtonNumber == item.key}">
        <a tabindex="0" (click)="onPageButtonClicked(item.key)"><span class="ng-star-inserted" >{{item.value}}</span></a></li>
      <li class="pagination-next ng-star-inserted button-pointer" [ngClass]="{'disabled':ClickedButtonNumber === paginationButtonCount}" (click)="nextButton()"><a tabindex="0"> Next <span class="show-for-sr">page</span></a></li>
    </ul>
  </div>
</div>

